export default __webpack_public_path__ + "terminated-staff-white-icon.svg";